import React from 'react';
import './Service.css';
import { BsApple } from 'react-icons/bs';
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import { NavLink } from "react-router-dom";
import './Slide.css';
import './About.css';
import './App.css';
import Footer from '../store/Components/Footer';




export default class Service extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}
	render() {
		return (
			<div>
				<div className='backgroundService relative flex justify-center items-center	 min-h-[500px]'>
					<img className='absolute top-0 left-0 object-cover brightness-[0.3] h-full z-[-1]' src='./images/back/services.jpg' alt=''></img>
					<h3 className='text-white text-[32px] capitalize md:text-[45px]'>Services</h3>
				</div>
				<div className='w-full mx-auto px-2 lg:px-0 my-0 lg:w-[950px] xl:w-[1100px]'>
					<div className="py-8">
						<div className="container mx-auto">
							<h1 className="text-2xl md:text-[32px] capitalize text-center text-[#ecc158] font-bold mb-8">About the process</h1>
							<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
								<div className="step-card p-4 rounded-lg">
									<h2 className="step-title">Step 1</h2>
									<p className="step-description">Start by doing something important here.</p>
								</div>

								<div className="step-card p-4 rounded-lg">
									<h2 className="step-title">Step 2</h2>
									<p className="step-description">Continue with the next crucial action.</p>
								</div>
								<div className="step-card p-4 rounded-lg">
									<h2 className="step-title">Step 3</h2>
									<p className="step-description">Move forward with this vital step.</p>
								</div>

								<div className="step-card p-4 rounded-lg">
									<h2 className="step-title">Step 4</h2>
									<p className="step-description">Complete the process with this final step.</p>
								</div>
							</div>
						</div>
					</div>

					<div className='grid gap-10 mt-10 mb-20 lg:gap-10 md:grid-cols-3 lg:grid-cols-4 '>
						<div className='md:col-span-2 md:row-span-2'>
							<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/service"><img src="./images/breakdown1.jpg" alt="asgfsdg" className='object-cover absolute h-full w-full top-0 left-0 transition-all' /></NavLink></div>

							<NavLink to="/service"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Emergency breakdown</span></NavLink>

							<h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/service"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">Vehicle trouble? One click for Battery Jump-start, Puncture Repair, Towing, and more to get you moving again.</span></NavLink></h2>
						</div>
						<div className=''>
							<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/service"><img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' /></NavLink></div>

							<NavLink to="/service"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Accidental help</span></NavLink>

							<h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/service"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">Your safety is our priority. In case of an accident, we offer Ambulance Service to the nearest hospital, Towing Service for your vehicle, and ensure your well-being.</span></NavLink></h2>
						</div>
						<div className=''>
							<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/service"><img src="./images/sparepartsservice.png" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all' /></NavLink></div>

							<NavLink to="/service"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Spare parts</span></NavLink>

							<h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/service"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">We offer top-brand spare parts with Trakify warranty for your peace of mind.</span></NavLink></h2>
						</div>
						<div className=''>
							<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/service"><img src="./images/breakdown1.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all' /></NavLink></div>

							<NavLink to="/service"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Accesories</span></NavLink>

							<h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/service"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">Enhance comfort and style with genuine TRACKIFY accessories. Backed by warranty for a stress-free experience.</span></NavLink></h2>
						</div>
						<div className=''>
							<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800"><NavLink className="relative block aspect-[5/4]" to="/service"><img src="./images/regularservice.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all' /></NavLink></div>

							<NavLink to="/service"><span className="inline-block text-xs font-medium tracking-wider uppercase   mt-5 text-emerald-700">Regular Service</span></NavLink>

							<h2 className="text-lg line-clamp-2 font-medium  tracking-normal text-black mt-2    dark:text-white"><NavLink to="/service"><span className="bg-gradient-to-r from-green-200 to-green-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px] dark:from-purple-800 dark:to-purple-900">Our doorstep pick-up and drop service makes vehicle repairs stress-free.</span></NavLink></h2>
						</div>
					</div>

					<div className='relative'>
						<img src='./images/ser/why.jpg' className='brightness-[0.5] absolute w-full z-[-1] h-full object-cover left-0 top-0' alt=''></img>
						<h3 className='text-xl md:text-[32px] capitalize text-[#ecc158] font-bold py-7 px-5'>the benefits of using MechOnTrack</h3>
						<div className='pb-8 px-2 md:px-4 grid grid-cols-2 md:grid-cols-4 gap-[10px] md:gap-[20px]'>
							<div className='flex py-8 bg-white rounded flex-col justify-between items-center gap-2'>
								<div className='w-[100px]'>
									<img src='./images/ser/pricing.png' alt='' />
								</div>
								<h4 className='capitalize text-[12px] sm:text-[14px] lg:text-[16px]'>competitive pricing</h4>
							</div>
							<div className='flex py-8 bg-white rounded flex-col items-center gap-2'>
								<div className='w-[100px]'>
									<img src='./images/ser/support.png' alt='' />
								</div>
								<h4 className='capitalize text-[12px] sm:text-[14px] lg:text-[16px]'>centeral service support</h4>
							</div>
							<div className='flex py-8 bg-white rounded flex-col items-center gap-2'>
								<div className='w-[100px]'>
									<img src='./images/ser/parts.png' alt='' />
								</div>
								<h4 className='capitalize text-[12px] sm:text-[14px] lg:text-[16px]'>genuine parts</h4>
							</div>
							<div className='flex py-8 bg-white rounded flex-col items-center gap-2'>
								<div className='w-[100px]'>
									<img src='./images/ser/workshop.png' alt='' />
								</div>
								<h4 className='capitalize text-[12px] sm:text-[14px] lg:text-[16px]'>well equipped workshop</h4>
							</div>
						</div>
						<div>
							<h3 className='text-xl md:text-[32px] capitalize text-[#ecc158] font-bold py-3 px-5'>What Keeps MechOnTrack Honest</h3>
							<p className="text-slate-200 px-5 pb-5">Lorem Ipsum is simply dummy text of the printing and typesetting industryLorem Ipsum is simply dummy text of the printing and typesetting industryLorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum is simply dummy text of the printing and typesetting industry
								Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
						</div>
					</div>

					<div className='py-12'>
						<h3 className='text-2xl md:text-[32px] capitalize text-center text-[#ecc158] font-bold mb-8'>Our Gallery</h3>
						<div className='container grid gap-10 mt-10 mb-20 lg:gap-10 md:grid-cols-3 lg:grid-cols-4 '>
							<div className=''>
								<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800 relative min-h-[200px]">
									<img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' />
								</div>
							</div>
							<div className=''>
								<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800 relative min-h-[200px]">
									<img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' />
								</div>
							</div>
							<div className=''>
								<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800 relative min-h-[200px]">
									<img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' />
								</div>
							</div>
							<div className=''>
								<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800 relative min-h-[200px]">
									<img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' />
								</div>
							</div>
							<div className=''>
								<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800 relative min-h-[200px]">
									<img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' />
								</div>
							</div>
							<div className=''>
								<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800 relative min-h-[200px]">
									<img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' />
								</div>
							</div>
							<div className=''>
								<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800 relative min-h-[200px]">
									<img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' />
								</div>
							</div>
							<div className=''>
								<div className=" overflow-hidden rounded-md bg-gray-100 transition-all hover:scale-105   dark:bg-gray-800 relative min-h-[200px]">
									<img src="./images/ac.jpg" alt="asgfsdg" height="600px" width="400px" className='object-cover absolute h-full w-full top-0 left-0 transition-all transition-all' />
								</div>
							</div>
						</div>
						<div className="mt-10 flex justify-center"><NavLink className="relative inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-3 py-2 pl-4 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:pointer-events-none disabled:opacity-40 dark:border-gray-500 dark:bg-gray-800 dark:text-gray-300" to="#/"><span>View all Photos</span></NavLink></div>
					</div>

					<div className='py-8 grid md:grid-cols-2 items-center'>
						<div className='flex flex-col gap-4 items-baseline'>
							<h3 className='text-xl md:text-[32px] capitalize text-center text-[#ecc158] font-bold'>App that suits you better</h3>
							<p className='text-[#666]'>Your one-stop solution for all things automotive. From repairs to maintenance, we've got you covered. Drive worry-free with our app.</p>
							<div className='flex flex-col gap-2'>
								<a href='/' className='flex gap-2 items-center text-[30px] border border-slate-900 rounded p-1 border-solid	hover:bg-slate-900 duration-300	 hover:text-white'><IoLogoGooglePlaystore /><span className='flex flex-col'>
									<span className='text-[12px] uppercase'>Get it on</span>
									<span className='text-[16px] capitalize'>Google play</span>
								</span></a>
								<a href='/' className='flex gap-2 items-center text-[30px] border border-slate-900 rounded p-1 border-solid	hover:bg-slate-900 duration-300	 hover:text-white'><BsApple /><span className='flex flex-col'>
									<span className='text-[12px] uppercase'>Download on the</span>
									<span className='text-[16px] capitalize'>App Store</span>
								</span></a>
							</div>
						</div>
						<div className='row-start-1	md:col-start-2'>
							<img src='./images/app.png' alt=''></img>
						</div>
					</div>

				</div>
				<Footer />
			</div >

		)
	}
}